import React, { useEffect, useState } from 'react';
import { Table, Button, Container, Row, Col, Spinner, Alert } from 'react-bootstrap';
import { ConsumoAPI_POST } from '../../../../backend/ConsumoAPI';
import { ConsultaAPI_URL } from '../../../../backend/ConsultaAPI';
import LoadingSpinner from '../../../components/LoadinSpinner';
import TitlePage from '../../../components/TitlePage';
import { ErroMsg, formatarData, SucessoMsg } from '../../../contents/VariaveisGlobais';
import { usePopUp } from '../../../components/BootBox';
import ResponsiveDataTable from '../../../components/DataTable';

function UsuariosLogados() {
    const [usuarios, setUsuarios] = useState([]);
    const [carregar, setCarregar] = useState(true);
    const { DisparaBootBox, FechaBootBox  } = usePopUp();

    const carregarUsuarios = async () => {
        try {
            setCarregar(true);
            const res = await ConsultaAPI_URL('sessao/');
            const data = res;
            setUsuarios(data);
        } catch (err) {
            ErroMsg('Erro ao carregar os usuários.');
        } finally {
            setCarregar(false);
        }
    };

    useEffect(() => {
        carregarUsuarios();
    }, []);

    const derrubarUsuario = (row) => {
        const idRow = row.original.Id;
        const Mensagem = `Tem certeza que deseja desconectar o Usuário: ${row.original.Usuario}?`
        
        DisparaBootBox('Confirma Desconexão do Usuário ?', Mensagem, null, idRow, handleConfirmDesconectar)
    }

    const handleConfirmDesconectar = async(id) => {
        FechaBootBox()

        try {
            await ConsumoAPI_POST(`sessao/logout/`, JSON.stringify({usuario: id}) );

            SucessoMsg("Usuário Desconectado!")
            carregarUsuarios();
        } catch (err) {
            ErroMsg('Erro ao derrubar o usuário.');
        }
    };

    return (
        <>
            <Row>
                <LoadingSpinner isLoading={carregar}/>
                <Col md="12" xs="12">
                    <TitlePage text="Usuários Logados"/>
                </Col>
            </Row>
            <Row>
                <Col md="12" xs="12">
                    <ResponsiveDataTable
                        columns={[
                            {
                                Header: "ID",
                                accessor: "Id",
                            },
                            {
                                Header: "Usuário",
                                accessor: "Usuario",
                            },
                            {
                                Header: "Data Login",
                                accessor: "DataLogin",
                                Cell: (e) => { return formatarData(e.value) }
                            },
                            {
                                Header: "Versão no Login",
                                accessor: "Versao",
                            },                            
                        ]} 
                        data={usuarios}
                        isIgnorar={true}
                        buttons= {[
                            {isVisual: true, action: derrubarUsuario, label: "Derrubar", icone: "FaUserMinus", style: "danger"}
                        ]}
                    />
                </Col>
            </Row>
        </>
    );
}

export default UsuariosLogados;
